import Router from "@/helpers/router";

import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "../lib/types";

const { LGA, ADMIN } = WHATS_NEW_AUDIENCES;

/**
 * Pipeline → Review → Bulk edit (C-16 S3, GLE-8410, C16-D442). Pipeline is
 * on, so the entry shows from its release to release + 14 days, two ET days
 * per LGA and Admin (C16-D425). Move the window with the release if it ships
 * later than 2026-10-28.
 */
export const PIPELINE_BULK_EDIT_2026_10_28: WhatsNewEntryI = {
  id: "2026-10-28-pipeline-bulk-edit",
  feature: "pipeline",
  startsAt: "2026-10-28T04:00:00.000Z",
  endsAt: "2026-11-11T05:00:00.000Z",
  title: {
    [LGA]: "Bulk edit is back in Pipeline",
    [ADMIN]: "Bulk edit is back in Pipeline",
  },
  intro: {
    [LGA]:
      "Edit every campaign group of your workspace in one grid, as in Command Center.",
    [ADMIN]:
      "Edit every campaign group of a workspace, or of all of them, in one grid, as in Command Center.",
  },
  sections: [
    {
      id: "pipeline-bulk-edit",
      audiences: [LGA, ADMIN],
      icon: WHATS_NEW_ICONS.SPARKLES,
      title: "Pipeline → Review → Bulk edit",
      items: [
        "Name, active, Target EU, base $ per QM and the lifecycle dates for every group, one row each.",
        "Each change saves when you leave its cell; Esc undoes what you typed.",
        "Campaigns and monthly targets stay in the group's own dialog.",
      ],
      link: { label: "Open Review", href: Router.managePipeline("review") },
    },
  ],
};
